(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2531],{

/***/ 33251:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/account/user/invoices",
      function () {
        return __webpack_require__(76890);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 76890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _components_I18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34769);
/* harmony import */ var _components_Authentication__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6990);
/* harmony import */ var _components___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(638);







var Page = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components___WEBPACK_IMPORTED_MODULE_4__/* .PageWrapper */ .FEV, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components___WEBPACK_IMPORTED_MODULE_4__/* .LoginOrErrorOrPage */ .ZA4, {
            errorMsg: props.errorMsg,
            notLogged: props.notLogged,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components___WEBPACK_IMPORTED_MODULE_4__/* .InvoicesPage */ .uZs, {
                invoices: props.invoices
            })
        })
    });
};
var CompletePage = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_I18n__WEBPACK_IMPORTED_MODULE_2__/* .WithLocale */ ._t, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Authentication__WEBPACK_IMPORTED_MODULE_3__/* .WithAuthentication */ .K, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Page, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props))
        }))
    }));
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (CompletePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(24458), __webpack_exec__(33251); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);